<template>
    <div class="account-page">
        <div>
            <div class="account-heading">
                <h2 class="d-none d-lg-inline">Account</h2>
                <h5>{{numEstablishments}} Establishment<template v-if="numEstablishments > 1">s</template>
                    <span class="account-heading-separator">|</span> {{numRoomTypes}} Room Type<template v-if="numRoomTypes > 1">s</template>
                    <span class="account-heading-separator">|</span> {{numRooms}} Room<template v-if="numRooms > 1">s</template>
                </h5>
            </div>

            <div v-if="loading" class="row">
                <div class="col text-center">
                    <spinner></spinner>
                </div>
            </div>

            <div v-if="loading && error" class="row mt-4">
                <div class="col text-center">
                    <div class="alert alert-danger">
                        {{infoMessage}}
                        <button v-if="loading" class="btn btn-primary" v-on:click="fetchBilling()">Reload</button>
                        <button v-on:click="fetchBilling()" class="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
            </div>

            <template v-if="!loading">

                <div class="row account-cards">
                    <div class="col-md-4 col-sm-12">
                        <div class="card">
                            <div class="card-body">
                                <h6>Renews On</h6>
                                <h4>
                                    <template v-if="billingInfo.subscription">
                                        {{friendlyDate(billingInfo.subscription.renewalDate)}}
                                    </template>
                                    <template v-else>
                                        No Subscription yet
                                    </template>
                                </h4>
                                <a href="#" v-on:click.stop="showTabReceipts">View receipts</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <div class="card">
                            <div class="card-body">
                                <h6>Subscription -
                                    <template v-if="billingInfo.subscription">
                                        <template v-if="isBilledMonthly">
                                            Monthly
                                        </template>
                                        <template v-if="isBilled6Monthly">
                                            6 Monthly
                                        </template>
                                        <template v-if="isBilledAnnually">
                                            Annual
                                        </template>
                                    </template>
                                    <template v-else>
                                        N/A
                                    </template>
                                </h6>
                                <h4>
                                    <template v-if="billingInfo.subscription">
                                        {{billingInfo.subscription.currency}} {{billingInfo.subscription.priceExVAT}} <span class="account-card__heading--supplement">(ex VAT)</span>
                                    </template>
                                    <template v-else>
                                        No Subscription yet
                                    </template>
                                </h4>
                                <a href="#" v-on:click.stop="showTabBillingDetails">View billing details</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <div class="card account-cards__credit-card">
                            <div class="card-body">
                                <h6>Card On File</h6>
                                <template v-if="hasCreditCard">
                                    <div class="account-cards__credit-card__PAN">
                                        <img v-if="primaryCard.paymentBrand === 'VISA'" src="../assets/visa.png">
                                        <img v-if="primaryCard.paymentBrand === 'Mastercard'" src="../assets/mastercard.png">
                                        <h4> **** {{primaryCard.last4Digits}}</h4>
                                    </div>
                                    <a href="#" v-on:click.stop="showTabBillingDetails">View / update credit cards</a>
                                </template>
                                <template v-else>
                                    <h4>No Card on File</h4>
                                    <a href="#" v-on:click.stop="showPopupUpdateCreditCard">Add credit card</a>
                                </template>
                                &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row account-cards">
                    <div class="col-md-4 col-sm-12">
                        <div class="card">
                            <div class="card-body">
                                <h6>SMS Credit</h6>
                                <h4>
                                    <template v-if="billingInfo.smsAccount">
                                        {{billingInfo.smsAccount.currency}} {{billingInfo.smsAccount.balance}} <span class="account-card__heading--supplement">(ex VAT)</span>
                                    </template>
                                    <template v-else>
                                        No Subscription yet
                                    </template>
                                </h4>
                                <a href="#" v-on:click.stop="showPopupTopUpSMSCredits">Top up credits</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <div class="card">
                            <div class="card-body">
                                <!-- <h6>WhatsApp</h6> -->
                            <h6>WhatsApp Credit</h6>
                                <h4>
                                    <template v-if="billingInfo.whatsAppAccount">
                                        <template v-if="billingInfo.whatsAppAccount.status === 'active'">
                                            {{billingInfo.whatsAppAccount.currency}} {{billingInfo.whatsAppAccount.balance}} <span class="account-card__heading--supplement">(ex VAT)</span>
                                        </template>
                                        <template v-else-if="billingInfo.whatsAppAccount.status === 'initiated' || billingInfo.whatsAppAccount.status === 'signing-up'">
                                            Signing up...
                                        </template>
                                    </template>
                                    <template v-else>
                                        Not Activated
                                    </template>
                                </h4>
                                <a href="#" v-on:click.stop="showPopupTopUpWhatsAppCredits">Top up credits</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <div class="card">
                            <div class="card-body">
                                <h6>Low Balance Notifications</h6>
                                <h4>Not Activated</h4>
    <!--                            <a href="#" v-on:click.stop="showTabNotifications">Edit</a>-->
                                Coming soon
                            </div>
                        </div>
                    </div>
                </div>

                <div ref="tabs" class="nav-tabs mt-5">
                    <li v-on:click="showTabOverview" v-bind:class="{ 'nav-tabs__item--selected' : isShowTabOverview }">Overview</li>
                    <li v-on:click="showTabWhatsApp" v-bind:class="{ 'nav-tabs__item--selected' : isShowTabWhatsApp }">WhatsApp</li>
                    <li v-on:click="showTabReceipts" v-bind:class="{ 'nav-tabs__item--selected' : isShowTabReceipts }">Receipts</li>
                    <li v-on:click="showTabBillingDetails" v-bind:class="{ 'nav-tabs__item--selected' : isShowTabBillingDetails }">Billing details</li>
    <!--                <li v-on:click="showTabNotifications" v-bind:class="{ 'nav-tabs__item&#45;&#45;selected' : isShowTabNotifications }">Notifications</li>-->
                </div>

                <div class="row">
                    <div class="col-12 mt-4">

                        <template v-if="isShowTabOverview">
                            <div class="text-center mt-4">
                                <h6>Coming soon</h6>
                                We are in the process of implementing a dashboard for you.
                            </div>
                        </template>

                        <template v-if="isShowTabWhatsApp">
                            <div class="whatsapp">
                                <div class="text-center mt-4">
                                    <h6>Coming soon</h6><br/>
                                We are in the process of implementing a dashboard for you.
                                </div>
                            </div>

                        </template>

                        <template v-if="isShowTabReceipts">
                            <div class="text-center mt-4">
                                <h6>No receipts</h6>
                                You have no receipts yet.
                            </div>
                        </template>

                        <template v-if="isShowTabBillingDetails">
                            <div class="card mb-4 credit-card-on-file">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-6">
                                            <h6>Credit Card On File</h6>
                                        </div>
                                        <div class="col-sm-12 col-md-6 text-right">
                                            <button class="btn"
                                                    v-bind:class="{'btn-primary' : !hasCreditCard, 'btn-secondary' : hasCreditCard}"
                                                    v-on:click.stop="showPopupUpdateCreditCard">Add Credit Card</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">

                                    <template v-if="hasCreditCard">
                                        <div v-for="(creditCard, index) of billingInfo.creditCards" v-bind:key="index" class="row mb-4">
                                            <div class="d-none d-md-block col-md-4">
                                                <div class="credit-card__card-view"
                                                    v-bind:class="{'credit-card__card-view--visa' : isCardVisa(creditCard), 'credit-card__card-view--mastercard' : isCardMastercard(creditCard)}">
                                                    <div class="credit-card__card-view__details">
                                                        <div class="credit-card__card-view__PAN">**** {{creditCard.last4Digits}}</div>
                                                        <div class="credit-card__card-view__expiry">{{creditCardExpiry(creditCard.expiryDate)}}</div>
                                                        <div class="credit-card__card-view__holder">{{creditCard.holder}}</div>
                                                    </div>
                                                    <div class="credit-card__card-view__brand ">
                                                        <img v-if="isCardVisa(creditCard)" src="../assets/visa_white.png">
                                                        <img v-if="isCardMastercard(creditCard)" src="../assets/mastercard.png">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-10 col-md-6 mt-3">
                                                <h6>{{creditCard.paymentBrand}} Credit Card</h6>
                                                Ending in <b>**** {{creditCard.last4Digits}}</b><br>
                                                Expires <b>{{creditCardExpiry(creditCard.expiryDate)}}</b><br><br>
                                                <template v-if="creditCard.defaultCard && numberOfCreditCards > 1">
                                                    <span class="text-note">Select another default to remove this card</span>
                                                </template>
                                                <template v-else>
                                                    <a href="#" v-on:click.stop.prevent="removeCard(creditCard)">Remove card</a>
                                                </template>
                                            </div>
                                            <div class="col-2 col-md-2 credit-card-on-file__primary-selector">
                                                <template v-if="creditCard.defaultCard">
                                                    Default
                                                </template>
                                                <template v-else>
                                                    <input v-model="creditCard.defaultCard" type="radio" v-bind:value="true" v-on:click="makeCardDefault(creditCard)">
                                                    <div>Make default</div>
                                                </template>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <div class="row mb-2">
                                            <div class="col-sm-12 col-md-6">
                                                Credit Card Number
                                            </div>
                                            <div class="col-sm-12 col-md-6">
                                                No card on file
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-sm-12 col-md-6">
                                                Expiry
                                            </div>
                                            <div class="col-sm-12 col-md-6">
                                                --/--
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>

                            <div class="card mb-4">
                                <div class="card-header">
                                    <h6>Billing Details</h6>
                                </div>
                                <div class="card-body">
                                    <form v-on:submit.prevent="updateBillingDetails">
                                        <ul>
                                            <li>
                                                <label for="billingContact">Contact Person</label>
                                                <input type="text" v-model="billingInfo.company.contact" id="billingContact" v-on:keydown="changedBillingDetails = true" class="short-question">
                                            </li>
                                            <li>
                                                <label for="billingEmail">Billing Email</label>
                                                <input type="text" v-model="billingInfo.company.email" id="billingEmail" v-on:keydown="changedBillingDetails = true" class="short-question">
                                            </li>
                                            <li>
                                                <label for="companyName">Company Name</label>
                                                <input type="text" v-model="billingInfo.company.name" id="companyName" v-on:keydown="changedBillingDetails = true" class="short-question">
                                            </li>
                                            <li>
                                                <label for="vatNumber">VAT number</label>
                                                <input type="text" v-model="billingInfo.company.vatNumber" id="vatNumber" v-on:keydown="changedBillingDetails = true" class="short-question">
                                            </li>
                                            <li>
                                                <label for="address1">Street Address 1</label>
                                                <input type="text" v-model="billingInfo.company.address1" id="address1" v-on:keydown="changedBillingDetails = true" class="short-question">
                                            </li>
                                            <li>
                                                <label for="address2">Street Address 2</label>
                                                <input type="text" v-model="billingInfo.company.address2" id="address2" v-on:keydown="changedBillingDetails = true" class="short-question">
                                            </li>
                                            <li>
                                                <label for="city">City</label>
                                                <input type="text" v-model="billingInfo.company.city" id="city" v-on:keydown="changedBillingDetails = true" class="short-question">
                                            </li>
                                            <li>
                                                <label for="province">State / Province</label>
                                                <input type="text" v-model="billingInfo.company.province" id="province" v-on:keydown="changedBillingDetails = true" class="short-question">
                                            </li>
                                            <li>
                                                <label for="country">Country</label>
                                                <select v-model="billingInfo.company.countryCode" id="country" v-on:change="changedBillingDetails = true">
                                                    <option>Select</option>
                                                    <option v-bind:value="getSouthAfrica().code">{{getSouthAfrica().name}}</option>
                                                    <option disabled>──────────</option>
                                                    <option v-for="country in countries" v-bind:key="country.code"
                                                            v-bind:value="country.code">{{country.name}}
                                                    </option>
                                                </select>
                                            </li>
                                            <li>
                                                <label for="postalCode">Postal Code</label>
                                                <input type="text" v-model="billingInfo.company.postalCode" id="postalCode" v-on:keydown="changedBillingDetails = true" class="short-question">
                                            </li>
                                            <li class="text-center">

                                                <div v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : updating, 'infobar-error' : error}">
                                                    {{infoMessage}}
                                                </div>

                                                <div v-if="updating" class="text-center">
                                                    <spinner></spinner>
                                                </div>

                                                <div v-show="!updating">
                                                    <button v-bind:aria-disabled="!changedBillingDetails"
                                                            v-bind:class="{'btn-disabled' : !changedBillingDetails}"
                                                            class="btn btn-primary"
                                                    >Save</button>
                                                </div>
                                            </li>
                                        </ul>
                                    </form>
                                </div>
                            </div>
                        </template>

                        <template v-if="isShowTabNotifications">
                            <div class="card mb-4 credit-card-on-file">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-6">
                                            <h6>Low Balance Notifications</h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form v-on:submit.prevent="updateBillingDetails">
                                        <ul>
                                            <li>
                                                When your SMS credit balance or WhatsApp credit balance fall below R50,
                                                you will received a notification email.
                                            </li>
                                            <li>
                                                <label for="notificationsActive">Status</label>
                                                <div id="notificationsActive" class="">
                                                    <i v-if="notificationsActive" v-on:click="toggleNotifications()"  class="fas fa-toggle-on toggle toggle__button--on"></i>
                                                    <i v-if="!notificationsActive" v-on:click="toggleNotifications()" class="fas fa-toggle-off toggle toggle__button--off"></i>
                                                    <span v-if="!notificationsActive">Disabled</span>
                                                    <span v-if="notificationsActive">Enabled</span>
                                                </div>
                                            </li>
                                            <li>
                                                <label for="notificationsEmail">Email</label>
                                                <input type="text" id="notificationsEmail" v-on:keydown="changedNotificationEmail = true" class="short-question">
                                            </li>
                                            <li class="text-center">
                                                <button v-bind:aria-disabled="!changedBillingDetails"
                                                        v-bind:class="{'btn-disabled' : !changedNotificationEmail}"
                                                        class="btn btn-primary"
                                                >Save</button>
                                            </li>
                                        </ul>
                                    </form>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>

            </template>
        </div>

<!--        <confirm-dialog v-bind:message="'Preparing to tokenise.'"-->
<!--                        v-bind:callbackPrimaryName="'hide-popup-credit-card'"-->
<!--                        v-if="isShowPopupUpdateCreditCard"/>-->

        <confirm-dialog v-bind:message="'This functionality is currently offline, and you will receive free SMSs for now'"
                        v-bind:callbackPrimaryName="'hide-popup-sms-credit'"
                        v-if="isShowPopupTopUpSMSCredits"/>

        <confirm-dialog v-bind:message="'This functionality is currently offline, and you will receive free WhatsApp messages for now'"
                        v-bind:callbackPrimaryName="'hide-popup-whatsapp-credit'"
                        v-if="isShowPopupTopUpWhatsAppCredits"/>

        <update-credit-card v-if="isShowPopupUpdateCreditCard">
            <form action="http://localhost:8081/account" class="paymentWidgets" data-brands="VISA MASTER AMEX"></form>
        </update-credit-card>
    </div>
</template>

<script>
    import { store, getters } from '@/store.js'


    // import EditMode from '../components/establishments/EditMode'
    import Spinner from '../components/Spinner.vue'
    import ConfirmDialog from '../components/ConfirmDialog.vue'
    import UpdateCreditCard from '../components/account/UpdateCreditCard'

    import {datesMixin} from "../mixins/DatesMixin"
    import {countriesMixin} from '../mixins/CountriesMixin'

    const TAB_OVERVIEW = 1, TAB_WHATSAPP = 2, TAB_RECEIPTS = 3, TAB_BILLING_DETAILS = 4, TAB_NOTIFICATIONS = 5;

    export default {
        name: "Account.vue",
        components: { Spinner, ConfirmDialog, UpdateCreditCard },
        mixins: [datesMixin, countriesMixin],
        data: function () {
            return {
                loading: true,
                billingInfo: null,
                tab: TAB_OVERVIEW,
                // tab: TAB_WHATSAPP,
                isShowPopupUpdateCreditCard: false,
                isShowPopupTopUpSMSCredits: false,
                isShowPopupTopUpWhatsAppCredits: false,
                changedNotificationEmail: false,
                changedBillingDetails: false,
                notificationsActive: false,
                updating: false,
                error: false,
                infoMessage: "",
                success: null,
            }
        },
        computed: {
            host: function() {
                return store.host;
            },
            numEstablishments: function() {
                if (store) {
                    return store.host.establishments.length;
                }
                return 0;
            },
            numRoomTypes: function() {
                if (store) {
                    return store.host.establishments.reduce( function(a, b){
                        return a + b['roomTypes'].length;
                    }, 0);
                }
                return 0;
            },
            numRooms: function() {
                if (store) {
                    return store.host.establishments.reduce( function(accumulator1, establishment) {
                        let roomsForEstablishment = establishment['roomTypes'].reduce( function(accumulator2, roomType) {
                            return accumulator2 + roomType['roomCount'];
                        }, 0);
                        return accumulator1 + roomsForEstablishment;
                    }, 0);
                }
                return 0;
            },
            isBilledMonthly: function() {
                return (this.billingInfo && this.billingInfo.subscription && this.billingInfo.subscription.periodicity === 'monthly');
            },
            isBilled6Monthly: function() {
                return (this.billingInfo && this.billingInfo.subscription && this.billingInfo.subscription.periodicity === 'six-monthly');
            },
            isBilledAnnually: function() {
                return (this.billingInfo && this.billingInfo.subscription && this.billingInfo.subscription.periodicity === 'annually');
            },
            hasCreditCard: function() {
                return this.billingInfo.creditCards.length > 0;
            },
            numberOfCreditCards: function() {
                return this.billingInfo.creditCards.length;
            },
            primaryCard: function() {
                if (this.hasCreditCard) {
                    for (let creditCard of this.billingInfo.creditCards) {
                        if (creditCard.defaultCard) {
                            return creditCard;
                        }
                    }
                }
                return null;
            },
            isWhatsAppInitiated: function() {
                return (this.billingInfo && this.billingInfo.whatsAppAccount !== null);
            },
            isShowTabOverview: function() {
                return this.tab === TAB_OVERVIEW;
            },
            isShowTabWhatsApp: function() {
                return this.tab === TAB_WHATSAPP;
            },
            isShowTabReceipts: function() {
                return this.tab === TAB_RECEIPTS;
            },
            isShowTabBillingDetails: function() {
                return this.tab === TAB_BILLING_DETAILS;
            },
            isShowTabNotifications: function() {
                return this.tab === TAB_NOTIFICATIONS;
            },
            canShowWhatsApp: function() {
                return getters.canShowWhatsApp();
            },
            isWhatsAppActive: function() {
                return this.isWhatsAppInitiated && this.billingInfo.whatsAppAccount.status === 'active';
            }
        },
        methods: {
            fetchBilling: function () {
                this.loading = true;
                this.error = false;
                this.$http.get('/guest-management/v1/companies/' + store.host.company.reference + '/billing', {
                    withCredentials: true
                }).then(response => {
                    this.billingInfo = response.data;
                    this.loading = false
                }).catch(error => {
                    this.error = true;
                    if (error.response) {
                        this.infoMessage = error.response.data.message
                    } else {
                        this.infoMessage = "Sorry, we can't seem to reach our servers! Please try again"
                    }
                }).finally(() => {
                    // this.loading = false
                })
            },
            showPopupUpdateCreditCard: function () {
                console.log("Showing update credit card flow");
                this.isShowPopupUpdateCreditCard = true;
            },
            hidePopupUpdateCreditCard: function () {
                this.isShowPopupUpdateCreditCard = false;
            },
            showPopupTopUpSMSCredits: function () {
                this.isShowPopupTopUpSMSCredits = true;
            },
            hidePopupTopUpSMSCredits: function () {
                this.isShowPopupTopUpSMSCredits = false;
            },
            showPopupTopUpWhatsAppCredits: function () {
                this.isShowPopupTopUpWhatsAppCredits = true;
            },
            hidePopupTopUpWhatsAppCredits: function () {
                this.isShowPopupTopUpWhatsAppCredits = false;
            },
            isCardVisa: function(creditCard) {
                if (creditCard && creditCard.paymentBrand === 'VISA') {
                    return true;
                }
                return false;
            },
            isCardMastercard: function(creditCard) {
                if (creditCard && creditCard.paymentBrand === 'MASTER') {
                    return true;
                }
                return false;
            },
            makeCardDefault: function(creditCard) {
                console.log("Making card default");
                this.$http.put('/guest-management/v1/companies/' + store.host.company.reference + '/billing/cards/' + creditCard.reference + '/make-default'
                ).then(response => {
                    console.log(response);
                    for (let tempCard of this.billingInfo.creditCards) {
                        if (tempCard.reference === creditCard.reference) {
                            tempCard.defaultCard = true;
                        } else {
                            tempCard.defaultCard = false;
                        }
                    }
                }).catch(error => {
                    this.error = true;
                    if (error.response && error.response.data.message) {
                        this.infoMessage = error.response.data.message;
                    } else {
                        this.infoMessage = "There was a problem removing your card. Please try again.";
                    }
                });
            },
            removeCard: function(creditCard) {
                console.log("Removing card");
                this.$http.delete('/guest-management/v1/companies/' + store.host.company.reference + '/billing/cards/' + creditCard.reference
                ).then(response => {
                    console.log(response);
                    for (let i = 0; i < this.billingInfo.creditCards.length; i++) {
                        if (this.billingInfo.creditCards[i].reference === creditCard.reference) {
                            this.billingInfo.creditCards.splice(i, 1);
                            return;
                        }
                    }
                }).catch(error => {
                    this.error = true;
                    if (error.response && error.response.data.message) {
                        this.infoMessage = error.response.data.message;
                    } else {
                        this.infoMessage = "There was a problem removing your card. Please try again.";
                    }
                });
            },
            showTabOverview: function () {
                this.tab = TAB_OVERVIEW;
                this.scrollTabsIntoView();
            },
            showTabWhatsApp: async function () {
                this.tab = TAB_WHATSAPP;
                this.scrollTabsIntoView();
            },
            showTabReceipts: function () {
                this.tab = TAB_RECEIPTS;
                this.scrollTabsIntoView();
            },
            showTabBillingDetails: function () {
                this.tab = TAB_BILLING_DETAILS;
                this.scrollTabsIntoView();
            },
            showTabNotifications: function () {
                this.tab = TAB_NOTIFICATIONS;
                this.scrollTabsIntoView();
            },
            scrollTabsIntoView: function() {
                this.$nextTick(() => {
                    const rect = this.$refs.tabs.getBoundingClientRect()
                    window.scrollTo({
                        top: window.pageYOffset + rect.top - 80,
                        left: rect.x,
                        behavior: "smooth",
                    })
                });
            },
            enableWhatsApp: async function (action) {
                console.log("Action = " + action);
                this.updating = true;
                this.error = false;
                if (action === 'enable') {
                    try {
                        let response = await this.$http.get('/guest-management/v1/companies/' + store.host.company.reference + '/whatsapp/enable');
                        console.log(response);
                    } catch (error) {
                        this.error = true;
                        if (error.response && error.response.data.message) {
                            this.infoMessage = error.response.data.message;
                        } else {
                            this.infoMessage = "There was a problem fetching the WhatsApp status. Please try again.";
                        }
                    } finally {
                        this.hidePopupActivateWhatsApp();
                    }
                } else {
                    this.hidePopupActivateWhatsApp();
                }
            },
            updateBillingDetails: async function() {
                if (!this.changedBillingDetails) {
                    return false;
                }
                this.infoMessage = "Updating billing details";
                this.updating = true;
                this.error = false;
                const body = {
                    reference: this.billingInfo.company.reference,
                    contact: this.billingInfo.company.contact,
                    email: this.billingInfo.company.email,
                    name: this.billingInfo.company.name,
                    vatNumber: this.billingInfo.company.vatNumber,
                    address1: this.billingInfo.company.address1,
                    address2: this.billingInfo.company.address2,
                    city: this.billingInfo.company.city,
                    province: this.billingInfo.company.province,
                    countryCode: this.billingInfo.company.countryCode,
                    postalCode: this.billingInfo.company.postalCode
                }
                this.$http.put('/guest-management/v1/companies/' + store.host.company.reference + '/billing', body
                ).then(response => {
                    console.log(response);
                    this.changedBillingDetails = false;
                    this.infoMessage = "Billing details updated";
                }).catch(error => {
                    this.error = true;
                    if (error.response && error.response.data.message) {
                        this.infoMessage = error.response.data.message;
                    } else {
                        this.infoMessage = "There was a problem updating your billing details. Please try again.";
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.updating = false;
                    }, 2000);
                });
            },
            toggleNotifications: function () {
                this.notificationsActive = !this.notificationsActive;
            }
        },
        mounted: async function() {
            this.fetchBilling();

            this.$root.$on('enable-whatsapp', this.enableWhatsApp);
            this.$root.$on('finished-updating-credit-card', this.hidePopupUpdateCreditCard);
            this.$root.$on('hide-popup-sms-credit', this.hidePopupTopUpSMSCredits);
            this.$root.$on('hide-popup-whatsapp-credit', this.hidePopupTopUpWhatsAppCredits);

            window.addEventListener("message", this.embeddedSignupInfoListener);
        },
        beforeDestroy () {
            this.$root.$off('enable-whatsapp', this.enableWhatsApp);
            this.$root.$off('finished-updating-credit-card', this.hidePopupUpdateCreditCard);
            this.$root.$off('hide-popup-sms-credit', this.hidePopupTopUpSMSCredits);
            this.$root.$off('hide-popup-whatsapp-credit', this.hidePopupTopUpWhatsAppCredits);

            window.removeEventListener("message", this.embeddedSignupInfoListener);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/pages/_account.scss";
    @import "../styles/components/_question_answer.scss";
</style>